import React from "react";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import CustomInput from "../../../../components/TextField/TextFeild";
import { updateUserProfile } from "../../../../store/slices/authSlice";
import InstagramIcon from "@mui/icons-material/Instagram";

const validationSchema = Yup.object({
  instagram: Yup.string().url().nullable(),
});

const Instagram = () => {
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      instagram: user?.attributes.instagram?.username
        ? `https://www.instagram.com/${user?.attributes.instagram?.username}`
        : "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting, setFieldError }) => {
      try {
        const extractUsername = (url) => {
          if (!url) return "";
          try {
            let urlObj = new URL(url.startsWith("http") ? url : `https://${url}`);
            return urlObj.pathname.replace(/^\/+/, "").split("/")[0]; // Extract username
          } catch (error) {
            return url;
          }
        };

        let payload = {};
        if (values.instagram) {
          payload.instagram = { username: extractUsername(values.instagram) };
        }else{
          payload.instagram = {};
        }
        const isForStation = user?.attributes?.isOwner == false ? true : false;
        await dispatch(
          updateUserProfile({
            message: "Instagram Page Updated Successfully.",
            values: payload,
            isForStation
          })
        );
      } catch (error) {
        console.error("Error updating Instagram:", error);
        setFieldError("instagram", "Failed to update Instagram page. Please try again.");
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <div className="ps-3">
      <form className="form_div row w-100 " onSubmit={formik.handleSubmit}>
        <div className="InnerHeading">
          <h4>Instagram</h4>
        </div>
        <div className="form-card col-9 d-flex justify-content-around align-items-center">
          <div className="form-elements w-75 d-flex align-items-end">
            <InstagramIcon
              style={{
                color: "#517FA4",
                width: "35px",
                fontSize: "30px",
                marginBottom: "5px",
                marginRight: "5px",
              }}
            />
            <CustomInput
              label="Instagram page address "
              id="instagram"
              name="instagram"
              value={formik.values.instagram}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.instagram && formik.errors.instagram}
            />
          </div>
          <div className="button-div">
            <button
              type="submit"
              className="btn btn-primary custom-submit-btn"
              disabled={formik.isSubmitting}
            >
              {formik.isSubmitting ? (
                <>
                  Updating...
                </>
              ) : (
                "Update"
              )}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Instagram;
